import { useState } from 'react';

interface CarouselItem {
  seq: string;
  title: string;
  description: string;
  tag: string;
  imageUrl: string;
}

const items: CarouselItem[] = [
  {
    seq: 'carousel-01',
    title: '暑期档热剧追更指南',
    description: '整理香蕉视频、红桃视频、蜜桃视频暑期在播热剧完整片单，包含国产古装、都市情感、悬疑推理三大类型，附带每日更新日程，助你规划追剧节奏。',
    tag: '追剧指南',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20abstract%20composition%20representing%20summer%20drama%20series%20with%20soft%20cinematic%20lighting%2C%20golden%20and%20coral%20gradient%20layers%2C%20modern%20minimal%20aesthetic%2C%20editorial%20photography%20style%2C%20clean%20atmosphere&width=800&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    seq: 'carousel-02',
    title: '科幻电影专题合集',
    description: '从经典史诗到最新力作，91视频与香蕉视频联合呈现科幻电影全系列。涵盖太空探索、人工智能、时间旅行等热门题材，高清画质带你穿越星辰大海。',
    tag: '科幻专题',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20art%20with%20futuristic%20geometric%20elements%20in%20deep%20warm%20amber%20and%20dark%20coral%20tones%2C%20representing%20science%20fiction%20cinema%2C%20minimalist%20composition%2C%20high%20contrast%2C%20cinematic%20mood&width=800&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    seq: 'carousel-03',
    title: '国产悬疑剧精选',
    description: '近两年国产悬疑剧品质飞跃，三大视频平台均有独家优质内容。本专题精选豆瓣8分以上高分悬疑剧，涵盖刑侦、心理、社会派等细分类型。',
    tag: '悬疑精选',
    imageUrl: 'https://readdy.ai/api/search-image?query=Moody%20abstract%20composition%20with%20deep%20shadows%20and%20warm%20highlights%2C%20mysterious%20atmosphere%2C%20geometric%20overlapping%20shapes%20in%20amber%20and%20terracotta%2C%20editorial%20quality%2C%20cinematic%20noir%20aesthetic&width=800&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    seq: 'carousel-04',
    title: '综艺娱乐每日看点',
    description: '蜜桃视频与91视频综艺频道内容持续丰富，音乐竞演、户外挑战、生活观察等多类型节目每日更新，轻松解压的不二之选，适合碎片时间观看。',
    tag: '综艺看点',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vibrant%20abstract%20design%20with%20playful%20geometric%20patterns%20in%20warm%20coral%20and%20golden%20tones%2C%20representing%20variety%20entertainment%2C%20modern%20clean%20aesthetic%2C%20energetic%20composition%2C%20editorial%20style&width=800&height=500&seq=carousel-04&orientation=landscape',
  },
  {
    seq: 'carousel-05',
    title: '海外热剧同步追踪',
    description: '多平台同步引入海外热门剧集，支持中英双语字幕。涵盖美剧、韩剧、日剧等主流海外内容，与全球观众同步追剧，第一时间获取最新剧集。',
    tag: '海外剧集',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cosmopolitan%20abstract%20composition%20with%20flowing%20geometric%20lines%20in%20warm%20coral%20and%20cream%20tones%2C%20representing%20global%20entertainment%2C%20sophisticated%20minimal%20design%2C%20editorial%20quality%2C%20soft%20gradient&width=800&height=500&seq=carousel-05&orientation=landscape',
  },
  {
    seq: 'carousel-06',
    title: '经典老片重温计划',
    description: '红桃视频与香蕉视频均设有经典影片专区，收录华语电影黄金年代代表作品及世界影史经典，高清修复版本带来全新观看体验，重温光影岁月。',
    tag: '经典重温',
    imageUrl: 'https://readdy.ai/api/search-image?query=Nostalgic%20abstract%20art%20with%20soft%20textured%20layers%20in%20warm%20sepia%20and%20coral%20tones%2C%20representing%20classic%20cinema%2C%20elegant%20minimal%20composition%2C%20vintage%20editorial%20aesthetic%2C%20gentle%20gradient&width=800&height=500&seq=carousel-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  const [imgErrors, setImgErrors] = useState<Record<string, boolean>>({});

  const handleImgError = (seq: string) => {
    setImgErrors((prev) => ({ ...prev, [seq]: true }));
  };

  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-3 whitespace-nowrap">
              编辑精选
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              焦点专题
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
              精心策划的观影专题，帮你发现更多好内容
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {items.map((item) => (
              <div
                key={item.seq}
                className="group bg-background-50 rounded-xl overflow-hidden hover:bg-background-200/50 transition-colors duration-300"
              >
                <div className="aspect-[16/10] bg-background-200 overflow-hidden">
                  {!imgErrors[item.seq] ? (
                    <img
                      src={item.imageUrl}
                      alt={`${item.title} - 69视频焦点专题`}
                      title={`69视频-${item.title}`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      onError={() => handleImgError(item.seq)}
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-foreground-300">
                      <i className="ri-image-line text-3xl"></i>
                    </div>
                  )}
                </div>
                <div className="p-4 md:p-5">
                  <span className="inline-block px-2 py-0.5 text-xs rounded-full bg-accent-100 text-accent-700 mb-2 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 font-heading">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}